window.$mm_work_plans_result = [];
window.$mm_work_plans_treeChangeStatus = false;
window.$mm_work_plans_page_number = 1;
window.$mm_work_plans_Glist = [];
window.$mm_work_plans_selectedRow = "";
window.$mm_work_plans_selectedWorkPlanIdentification = "";
window.$mm_work_plans_content = [];
window.$mm_work_plans_lastUsedTableFilter = [];
window.$mm_work_plans_scroll_change = false;
window.$mm_work_plans_filterClickStatus = false;
window.$mm_work_plans_filterLastIds = [];
window.$mm_work_plans_searchInputId = null;
window.$mm_work_plans_columnList = [];
window.$mm_work_plans_plannigAlgemeenGisratio = [];
window.$mm_work_plans_plannigStatus = [];
window.$mm_work_plans_maatregelNaam = [];
window.$mm_work_plans_werkplanNaam = [];
window.$mm_work_plans_planningspatroonNaam = [];
window.$mm_work_plans_planningsperiodeNaam = [];
window.$mm_work_plans_budgetNaam = [];
window.$mm_work_plans_beheereenheidNaam = [];
window.$mm_work_plans_beheeractiviteitLaag = [];
window.$mm_work_plans_disciplineNaam = [];
window.$mm_work_plans_statusTijdstipVerzonden = [];
window.$mm_work_plans_filterCheckControlGPlannig = [false, false];
window.$mm_work_plans_gvv = 1;
window.$mm_work_plans_last_search_id = 1;
window.$mm_work_plans_table_total_row_count = 0;
window.$mm_work_plans_table_selected_row_count = 0;
window.$mm_work_plans_statusCheck = false;
window.$mm_work_plans_columnListPure = null;
window.$mm_work_plans_refresh = function (){};
window.$mm_sideMenu_isSubFolderInTreeChildrenContext = false;
window.$mm_work_plans_filterContent = [
  { key: "werkplan-naam", and_or: "AND", values: [], datatype: "STRING" },
];
window.$mm_work_plans_filterCheckControl = [
  ["status-detailplanning", false, false],
  ["status-budget", false, false],
  ["status-uitvoering", false, false],
  ["status-werkplan", false, false],
  ["planning-iscorrectiefonderhoud", false, false],
  ["status-verzonden", false, false],
];
window.$mm_work_plans_filterClickControl = [
  ["status-detailplanning", false],
  ["status-budget", false],
  ["status-uitvoering", false],
  ["status-werkplan", false],
  ["planning-iscorrectiefonderhoud", false],
  ["status-verzonden", false],
];
window.$mm_work_plans_actions = [
  {
    id: "17a25835-e4f8-4189-bcaa-30b7194c7c2b",
    text: "Plaats in detailplanning",
    class: "locate",
    modal: "plaats_in_detailplanning",
  },
  {
    id: "57d136a2-9749-46d4-85c4-edda4de75409",
    text: "Plaats in budget",
    class: "locate",
    modal: "plaats_in_budget",
  },
  {
    id: "3a98846b-67c1-4192-9edc-b980f10898b8",
    text: "Wijzig status",
    class: "locate",
    modal: "wijzig_status",
  },
  {
    id: "56785c54-8059-46ae-8b7f-250ce971a539",
    text: "Plaats in uitvoering",
    class: "locate",
    modal: "plaats_in_uitvoering",
  },
  {
    id: "b57232b9-090e-45f8-9729-3c768e12f650",
    text: "Verwijder uit uitvoering",
    class: "locate",
    modal: "verwijder_uitvoering",
  },
  {
    id: "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
    text: "Plaats in werkplan",
    class: "locate",
    modal: "plaats_in_werkplan",
  },
  {
    id: "nature_protection",
    text: "Natuurbeschermingscheck",
    class: "locate",
    modal: "plannig_natuurbeschermingscheck_modal",
  },
  {
    id: "wp_toon_dossiers_op_kaart",
    text: "wp_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
];

window.$mm_work_plans_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>work-plans",
        column_list: [
          "checkbox",
          "active",
          "status_detailplanning",
          "status_budget",
          "status_uitvoering",
          "status_werkplan",
          "planning_iscorrectiefonderhoud",
          "status_verzonden",
          "Gisratio Id",
          "Werkplan",
          "Status",
          "Naam maatregel",
          "Laag",
          "Naam beheereenheid",
          "Naam discipline",
          "Tijdstip verzonden",
          "Datum aangemaakt",
          "Datum laatst gewijzigd",
        ],
      },
    ],
  },
};
